import { Marketplace } from './marketplace';
/**
 * EmptyMarketplace with undefined marketplaceId, locale, and currencyCode
 */
class EmptyMarketplace extends Marketplace {
}
/**
 * This class providing a provider generate EmptyMarketplace,
 * as default marketplace provider in marketplace-creator
 */
// tslint:disable-next-line:max-classes-per-file
export class EmptyMarketplaceProvider {
    getMarketplace() {
        return EmptyMarketplaceProvider.emptyMarketplace;
    }
}
EmptyMarketplaceProvider.emptyMarketplace = new EmptyMarketplace();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZW1wdHktbWFya2V0cGxhY2UtcHJvdmlkZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZW1wdHktbWFya2V0cGxhY2UtcHJvdmlkZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUU1Qzs7R0FFRztBQUNILE1BQU0sZ0JBQWlCLFNBQVEsV0FBVztDQUFHO0FBRTdDOzs7R0FHRztBQUNILGdEQUFnRDtBQUNoRCxNQUFNLE9BQU8sd0JBQXdCO0lBRzFCLGNBQWM7UUFDakIsT0FBTyx3QkFBd0IsQ0FBQyxnQkFBZ0IsQ0FBQztJQUNyRCxDQUFDOztBQUp1Qix5Q0FBZ0IsR0FBZ0IsSUFBSSxnQkFBZ0IsRUFBRSxDQUFDIn0=